import { render, staticRenderFns } from "./DownIcon.vue?vue&type=template&id=c556f11c&scoped=true&"
import script from "./DownIcon.vue?vue&type=script&lang=ts&"
export * from "./DownIcon.vue?vue&type=script&lang=ts&"
import style0 from "./DownIcon.vue?vue&type=style&index=0&id=c556f11c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c556f11c",
  null
  
)

export default component.exports